// export const dev = 'https://loveseven.changelifedev.com'
export const dev = 'https://loveseven-api-e53a466ee6934a03a7e2bfb5b0d7e015.changelifechurch.com'
//export const dev = 'https://localhost:7238'
export const prod = 'https://loveseven-api-e53a466ee6934a03a7e2bfb5b0d7e015.changelifechurch.com'